<template>
  <b-modal
    v-model="isShow"
    :centered="true"
    :title="title"
    :cancel-title="cancelTitle"
    :ok-title="okTitle"
    @ok="modalOk"
    @cancel="modalCancel"
    @close="modalClose"
    @show="resetModal"
  >
    <form ref="prompt-form" @submit.stop.prevent="handleSubmit">
      <b-form-group :state="formState" :label="message" :invalid-feedback="invalid">
        <b-form-input v-model="formValue" :state="formState" required></b-form-input>
      </b-form-group>
    </form>
  </b-modal>
</template>
<script>
export default {
  data() {
    return {
      isShow: false,
      message: "default message",
      title: "Confirm",
      cancelTitle: "取消",
      okTitle: "确定",
      ok: null,
      cancel: null,
      close: null,
      regex: /.+/,
      invalidTips: "",
      formValue: "",
      formState: null
    };
  },
  methods: {
    handleSubmit() {
      this.formState = this.regex.test(this.formValue);
      // Exit when the form isn't valid
      if (!this.formState) return;

      if (this.ok) this.ok(this.formValue);
      // Hide the modal manually
      this.$nextTick(() => {
        this.isShow = false;
      });
    },
    resetModal() {
      this.formValue = "";
      this.formState = null;
    },
    modalOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    modalCancel() {
      if (this.cancel) this.cancel();
    },
    modalClose() {
      if (this.close) this.close();
    }
  },
  computed: {
    invalid() {
      return this.invalidTips || "invalid input, expected: " + this.regex;
    }
  }
};
</script>